import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/sections/Footer";

const HOME_TITLE = "OrderHalal.ai: AI Voice Ordering for Restaurants";
const HOME_DESC =
  "An AI assistant answers your restaurant's calls, takes orders accurately, and drops them right into your POS, 24/7.";

const LegalLayout = ({ title, effectiveDate, metaDescription, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prevTitle = document.title;
    const metaEl = document.querySelector('meta[name="description"]');
    const prevDesc = metaEl ? metaEl.getAttribute("content") : HOME_DESC;
    document.title = title;
    if (metaEl && metaDescription) metaEl.setAttribute("content", metaDescription);
    return () => {
      document.title = prevTitle || HOME_TITLE;
      if (metaEl) metaEl.setAttribute("content", prevDesc || HOME_DESC);
    };
  }, [title, metaDescription]);

  return (
    <div className="grain min-h-screen bg-ink text-cream flex flex-col">
      <header className="border-b border-line">
        <div className="max-w-3xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="font-heading text-lg md:text-xl font-bold tracking-tight" data-testid="legal-logo-link">
            OrderHalal<span className="text-terra">.ai</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-sand hover:text-terra transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <article className="max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-24">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter text-cream leading-[1.1]">
            {title}
          </h1>
          <p className="mt-4 text-sm text-sand/70">
            <span className="font-semibold text-sand">Effective Date:</span> {effectiveDate}
          </p>
          <div className="mt-12 space-y-10">{children}</div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-heading text-xl sm:text-2xl font-medium text-cream tracking-tight">{heading}</h2>
    <div className="mt-4 space-y-4 text-base sm:text-lg text-sand leading-relaxed">{children}</div>
  </section>
);

export default LegalLayout;
